<template>
    <v-layout row wrap justify-center>
        <v-flex sm11 xs11 md11 lg11>
            <v-data-table :headers="headers" no-results-text="Nenhum registro encontrado" :items-per-page="5"
                :must-sort="true" :items="values" color="secondary" loading-text="Carregando registros...aguarde">
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>

import _ from 'lodash'

var cmp

export default {
    components: {
        
    },
    data() {
        return {
            headers: [
                { text: "Data", value: "dtBaixa"},
                { text: "Dias alojados", value: "nrDiasAlojamento" },
                { text: "Semana", value: "nrSemana" },
                { text: "Motivo", value: "nmCausa" },
                { text: "Ração", value: "nmRacao"},
                { text: "Medicada", value: "dsMedicada" },
                { text: "Qtd", value: "qtAnimaisMortos" }
            ],
        }
    },
    props:{
        values: Array
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        cmp = this
    },
}
</script>

<style>

</style>
